import { isCurrentShelemView } from "@bing/engine-shelem";
import type { ComponentProps, ReactNode } from "react";
import { Boot } from "../components/Boot";
import { fa } from "../i18n/fa";
import { ShelemTable } from "../screens/ShelemTable";

/**
 * THE شلم TABLE — or, on a frame this web cannot draw, the platform's «در حال به‌روزرسانی هستیم…»
 * (`fa.errors.MAINTENANCE`) with the table's own exit, never a crash (the final review's I3 class).
 * The joint push puts the web first (web → game-server), so a NEW web can meet the OLD game-server,
 * whose views — master's شلم engine — lack what the table reads (`isCurrentShelemView`). Both شلم
 * containers render the table through this; the notice is the shared `Boot` screen's error form.
 */
export function ShelemTableOrUpdating(props: ComponentProps<typeof ShelemTable>): ReactNode {
  if (!isCurrentShelemView(props.view))
    return (
      <Boot error={fa.errors.MAINTENANCE} onLeave={props.onLeave} leaveLabel={fa.shelem.leave} />
    );
  return <ShelemTable {...props} />;
}
